<template>
  <multiselect
    :placeholder="customPlaceholder"
    v-model="selected"
    :options="formOptions"
    label="name"
    trackBy="id"
    :loading="loading"
  ></multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "FormSelector",
  components: { Multiselect },
  props: {
    options: {
      type: Object,
      default: () => {
        return {};
      }
    },
    selectedItem: {
      type: String,
      default: ""
    },
    customPlaceholder: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formOptions() {
      if (this.options.options && this.options.options.length) {
        if (this.options.field === "cropstage") {
          return this.options.options;
        } else {
          return this.options.options.sort((a, b) =>
            a.name > b.name ? 1 : b.name > a.name ? -1 : 0
          );
        }
      } else {
        return [];
      }
    },
    selected: {
      get() {
        return (
          (this.selectedItem &&
            this.options.options &&
            this.options.options.find(
              option => option.id === this.selectedItem
            )) ||
          null
        );
      },
      set(value) {
        this.$emit("change", {
          selected: (value && value.id) || null,
          field: this.options.field
        });
      }
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
